import { gql } from '@apollo/client';

const Fragments = {
  scheduleTypeCellParamTemplateItem: gql`
    fragment scheduleTypeCellParamTemplateItem on ScheduleTypeCellParamTemplateItem {
      scheduleTypeCellParamTemplateId
      templateName
      activeYN
      scheduleTypeId
      seasonalityTypeId
      monthsNo
      isEditable
      scheduleTypeCellParamTemplateDetails
    }
  `
};
export default Fragments;
